export default __webpack_public_path__ + "static/O0177-6e4c1c1333335204abbc9fc58a18ec0e.png";